import { SignIn } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";
import { opsHead } from "~/head";

export const Route = createFileRoute("/sign-in")({
  head: () => opsHead("Sign In"),
  component: () => <View />,
});

const View = () => {
  return (
    <div className="flex h-full items-center justify-center bg-gradient-to-t bg-zinc-50 from-zinc-200 to-zinc-50 font-text">
      <SignIn
        routing={"path"}
        path={"/sign-in"}
        fallbackRedirectUrl={"/"}
        appearance={{
          elements: {
            rootBox: "shadow-none font-title text-zinc-700",
            cardBox: "shadow-md bg-white rounded-md",
            header: "",
            headerTitle:
              "font-title font-medium text-base text-left text-zinc-700",
            headerSubtitle: "text-sm text-left text-zinc-500",
            headerBackRow: "mb-0",
            logoBox: "h-8 flex flex-col items-start",
            logoImage: "h-8",
            socialButtonsIconButton:
              "border-transparent bg-zinc-50 grayscale rounded-sm hover:border-brand-800 hover:grayscale-0 hover:bg-white",
            formHeader: "px-6 py-3 bg-zinc-100 rounded-sm",
            formHeaderTitle: "text-zinc-700",
            formHeaderSubtitle: "text-zinc-500 font-text",
            formButtonPrimary:
              " bg-brand-700  text-zinc-100 rounded-sm py-3 tracking-label normal-case text-sm font-normal border-solid border border-transparent after:!shadow-none !shadow-none hover:text-white hover:bg-brand-500 hover:border-brand-500",
            formFieldLabel: "font-title font-normal text-zinc-600",
            formFieldInput:
              "leading-6 text-zinc-700 text-base rounded-sm shadow-sm",
            formResendCodeLink: "text-brand-800 tracking-tight",
            formFieldAction: "font-title font-normal underline text-brand-800",
            footerActionLink: "font-title font-normal underline text-brand-800",
            dividerLine: "bg-zinc-200",
            dividerText: "text-zinc-400 font-normal",
            identityPreview: "rounded-full pl-2",
            identityPreviewAvatarBox: " w-8 h-8",
            identityPreviewText: "text-zinc-700",
            identityPreviewEditButtonIcon: "w-4 text-zinc-500",
            alternativeMethodsBlockButtonText: "tracking-label",
          },
        }}
      />
    </div>
  );
};
